import { render, staticRenderFns } from "./ColumnOptions.vue?vue&type=template&id=b0442822&scoped=true&"
import script from "./ColumnOptions.vue?vue&type=script&lang=js&"
export * from "./ColumnOptions.vue?vue&type=script&lang=js&"
import style0 from "./ColumnOptions.vue?vue&type=style&index=0&id=b0442822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0442822",
  null
  
)

export default component.exports